const splotchCopy = [
    {
        title: 'Footprint',
        body: (
            <>
                <p>
                    Sol drew two drawings, or footprints, of the structure he
                    wanted to make in fiberglass. The heights footprint detailed
                    the various heights of the structure. The color division
                    footprint indicated where each color would go.
                </p>
            </>
        ),
        in: 0,
        out: 60,
    },
    {
        title: 'Height Map',
        body: (
            <>
                <p>
                    Yoshi scanned these drawings into his computer for
                    prefabrication. He converted the heights footprint to
                    grayscale, enabling him to see how the structure would
                    appear in reality.
                </p>
            </>
        ),
        in: 120,
        out: 170,
    },
    {
        title: 'Computer Modeling ',
        body: (
            <>
                <p>
                    Yoshi used digital tools to refine the image of the
                    structure in the computer. This allowed him to see the final
                    look and size of the piece before its construction.
                </p>
            </>
        ),
        in: 200,
        out: 260,
    },
    {
        title: 'Dimension',
        body: (
            <>
                <p>
                    The color division footprint placed each color over the
                    grayscale model, resulting in a precise aerial view of the
                    Splotch. It was now ready to build!
                </p>
            </>
        ),
        in: 400,
        out: 502,
    },
];

export default splotchCopy;
